<app-section id="downloads" ornament="left">
  <span headline i18n="download@@download.headline">Downloads</span>
  <section id="all-downloads" class="text-center">
    <div class="windows download">
      <h5 i18n="Windows@@downloads.windows.headline">Standalone Clients</h5>
      <div class="explainText" i18n="explain@@download.windows.explaintext">Here you can download our standalone versions of Arkheim.</div>
      <div class="row justify-content-center">
        <a href="https://www.arkheim.com/PATCH/ArkheimLauncherInstaller.exe" angulartics2On="click" angularticsAction="downloadWindows" angularticsCategory="download">
          <div class="boxContainer windows">
            <div class="icon">
              <i class="fab fa-windows fa-5x primary"></i>
              <i class="fas fa-file-download fa-5x hover"></i>
            </div>
            <div class="name primary" i18n="windows@@download.windows.client">Windows</div>
            <div class="name hover" i18n="download@@download.windows.download">Download</div>
            <!--
              <div class="comingSoon" i18n="forum@@download.mac.client">
                <span>Coming soon</span>
              </div>
            -->
          </div>
       </a>
       <!-- <a href="https://static.arkheim.com/PATCH/ArkheimLauncherInstaller.exe" target="_blank" angulartics2On="click" angularticsAction="downloadMac" angularticsCategory="download"> -->
          <div class="boxContainer mac">
            <div class="icon">
              <i class="fab fa-apple fa-5x"></i>
            </div>
            <div class="name" i18n="mac@@download.mac.client">Mac</div>
            <div class="comingSoon">
              <span i18n="maccomingSoon@@download.mac.comingSoon">Coming soon</span>
            </div>
          </div>
       <!-- </a> -->
      </div>
    </div>
    <div class="stores download">
      <h5 i18n="stores@@downloads.stores.headline">Mobile Versions</h5>
      <div class="explainText" i18n="explain@@download.stores.explaintext">There are app versions for iOS & Android available in the App-Stores.</div>
      <div class="row justify-content-center">
        <android-button></android-button>
        <ios-button></ios-button>
      </div>
    </div>
  </section>
</app-section>
    
